import { getAxiosClient } from "../../axios-client";
import {
  GetOperatorClientsByIdBody,
  GetOperatorClientsByIdResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const getOperatorClientsById = async (
  body: GetOperatorClientsByIdBody
) => {
  return await axiosClient.ax.post<GetOperatorClientsByIdResponse>(
    "/Clients/GetAllClients",
    body
  );
};
